import { render, staticRenderFns } from "./KasbonApproval.vue?vue&type=template&id=7f192ed3"
import script from "./KasbonApproval.vue?vue&type=script&lang=js"
export * from "./KasbonApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports